import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "@/app-shell";

const DiffPage = lazy(() => import("@/pages/diff-page"));
const JsonPage = lazy(() => import("@/pages/json-page"));
const NricFinPage = lazy(() => import("@/pages/nric-fin-page"));
const DaysBetweenPage = lazy(() => import("@/pages/days-between-page"));

export function App() {
  return (
    <Suspense
      fallback={
        <main className="grid min-h-screen place-items-center">
          Loading utility…
        </main>
      }
    >
      <Routes>
        <Route element={<AppShell />}>
          <Route index element={<Navigate to="/diff" replace />} />
          <Route path="diff" element={<DiffPage />} />
          <Route path="json" element={<JsonPage />} />
          <Route path="nric-fin" element={<NricFinPage />} />
          <Route path="days-between" element={<DaysBetweenPage />} />
          <Route path="*" element={<Navigate to="/diff" replace />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
